<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("CHAIN_TRAVEL_AGENT_INFOMATION") }}</h4>
    </div>
    <v-progress-linear
      color="warning"
      indeterminate
      rounded
      height="3"
      v-if="isLoading"
    ></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="!isLoading">
      <v-spacer />
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-2">{{ $t("CHAIN_TRAVEL_AGENT_INFOMATION") }}</label>
          <div class="d-flex">
            <div class="pl-2 w-30">
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("TA_NAME")
                }} 1</span>
                <span class="booking-detail-content">
                  {{ data.nameVi }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("TA_CODE")
                }} 2</span>
                <span class="booking-detail-content">
                  {{ data.travelAgentCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("DESCRIPTION")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.noteVi }} 
                </span>
              </div>
            </div>
            <div class="pl-5">
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("_CONTRACT.TAX_CODE")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.taxCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("ENTERPRISE_CODE")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.enterpriseCode }} 
                </span>
              </div>
              <div class="booking-detail-info-wrapper">
                <span class="booking-detail-label booking-detail-label-width text-primary">{{
                  $t("ADDRESS")
                }}</span>
                <span class="booking-detail-content">
                  {{ data.addressVi }}{{ data.cityVi ? ", " +  data.cityVi : ""}}{{ data.countryCode3 && locations.find(e => e.id === data.countryCode3) ? ", " +  locations.find(e => e.id === data.countryCode3).label : "" }}
                </span>
              </div>
            </div>
          </div>
        </v-card>
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-2">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
          <div v-for="(contact, index) in data.travelAgentContacts" :key="index">
            <div class="d-flex justify-">
              <div class="pl-2 w-30">
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("FIRST_NAME_REPRESENT")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.firstName }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("LAST_NAME_REPRESENT")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.lastName }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("POSITION")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.position }} 
                  </span>
                </div>
              </div>
              <div class="pl-5">
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("_EDIT_USER.PHONE_NUMBER")
                  }} 1</span>
                  <span class="booking-detail-content">
                    {{ contact.phone }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("_EDIT_USER.PHONE_NUMBER")
                  }} 2</span>
                  <span class="booking-detail-content">
                    {{ contact.mobile }} 
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("Email")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.email }}
                  </span>
                </div>
                <div class="booking-detail-info-wrapper">
                  <span class="booking-detail-label booking-detail-label-width text-primary">{{
                    $t("ADDRESS")
                  }}</span>
                  <span class="booking-detail-content">
                    {{ contact.address }}
                  </span>
                </div>
              </div>

            </div>
            <v-divider v-if="index < 2 - 1" />
          </div>
        </v-card>
        <v-card class="h-100 border p-3 mb-3" elevation="0">
          <label class="label-title mb-3">{{ $t("INFOMATION_OF_BANK_ACCOUNT") }}</label>
          <div class="pl-2 ">
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK_ACCOUNT")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bankAccount }} 
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("ACCOUNT_HOLDER")
              }}</span>
              <span class="booking-detail-content">
                {{ data.accountHolder }} 
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bank }}
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">{{
                $t("_CONTRACT.BANK_BRANCH")
              }}</span>
              <span class="booking-detail-content">
                {{ data.bankBranch }}
              </span>
            </div>
            <div class="booking-detail-info-wrapper">
              <span class="booking-detail-label booking-detail-label-width text-primary">Swift Code</span>
              <span class="booking-detail-content">
                {{ data.swiftCode }}
              </span>
            </div>
          </div>
        </v-card>
        <b-row>
          <v-col>
            <div class="btn-bottom">
              <v-btn depressed class="" @click="back">{{ $t("BACK") }}</v-btn>
              <!-- <v-btn color="primary" class="pl-10 pr-10" @click="save" :loading="loading">{{
                $t("SAVE")
              }}</v-btn> -->
            </div>
          </v-col>
        </b-row>
      </div>
    </v-form>
  </div>
</template>
<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}
</style>
<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};
import store from "@/plugins/store";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { agentService } from "@/_services/HotelSetting/agent.service.js";
import { systemService } from "@/_services/system-data.service.js";

import { _alert } from "@/_helpers/function.js";

export default {
  components: {},
  props: {
    nextTab: Function,
  },
  created() {
    this.initialize();
  },
  mounted() {},
  data() {
    return {
      data: {
        travelAgentCode: "",
        nameVi: "",
        email: "",
        swiftCode: null,
        website: null,
        bank: "",
        bankAccount: "",
        taxCode: "",
        addressVi: "",
        mobile: null,
        phone: "",
        fax: "",
        cityVi: "",
        countryCode3: "VN",
        enterpriseCode: "",
        firstName: "",
        lastName: "",
        noteVi: "",
        id: "",
        accountHolder: null,
        position: null,
      },
      isEdit: false,
      applySetting: [],
      unApplySetting: [],
      isLoading: true,
      systemLang: this.$i18n.locale,
      locations: [],
      sectionConfigs: {
        default: {
          limit: 4,
          ulClass: { "data-darren": true },
          liClass: { "elf-row": true },
        },
        Elf: {
          limit: 6,
        },
      },
      suggestion: null,
      loading: false
    };
  },
  computed: {},
  watch: {
    tab(value) {
      this.langTab = value ? "en" : "vi";
    },
    listOtpsBed: {
      handler(value) {},
      deep: true,
    },
  },
  methods: {
    mapCity(data) {
      this.data.cityVi = data.item
    },
    async getLocation() {
      await chainService.getCountry(this.defaultI18n).then((res) => {
        this.locations = res.data.map((x) => {
          return {
            id: x.code,
            label: x.title,
          };
        });
        this.getSuggestion();
        this.isLoading = false;
      });
    },
    async getSuggestion() {
      await systemService.getLocations().then((res) => {
        this.suggestion = res.data.map((x) => {
          return {
            locType: x.locType,
            name: x.i18ns.find((x) => x.lang == this.defaultI18n).name,
          };
        });
      });
    },

    async initialize() {
      // _resetErrorState(this.ferrors);
      let id = this.$route.params.id;
      if (id != "00000000-0000-0000-0000-000000000000") {
        agentService.getChainTravelAgentInfo(id).then((res) => {
          if (res.responseCode == 0) {
            this.data = res.data;
            this.isEdit = true;
          }
        });
      } else {
        this.isEdit = false;
      }
      this.getLocation();
      this.isLoading = false;
    },
    back() {
      this.$router.push({ name: "agent-hotel" });
    },
    clickSelectAllChannel() {
      // this.data.channels = [];
      if (this.selectAllChannel) {
        this.listOfChannels.forEach((e) => {
          this.data.channels.push(e.id);
        });
      } else {
        this.data.channels = [];
      }
    },
    clickSelectAllMarket() {
      // this.data.markets = [];
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach((e) => {
          this.data.markets.push(e.id);
        });
      } else {
        this.data.markets = [];
      }
    },
    save() {
      this.loading = true;
      let form_validate = this.$refs.form.validate();

      if (!form_validate) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        this.loading = false;
        const el = document.querySelector(".v-messages.error--text:first-of-type");
        el.scrollIntoView();
        
        return false;
      }

      let updatedData = Object.assign({}, this.data);
      updatedData.travelAgentCode =  updatedData.travelAgentCode.toUpperCase();
      if (this.isEdit) {
        agentService.updateAgent(updatedData).then((res) => {
          this.loading = false;
          _alert(res, this.$t(res.data), false);
        });
      } else {
        agentService.createAgent(updatedData).then((res) => {
          if (res.responseCode === 0) {
            _alert(res, this.$t(res.data), false);
            this.back();
          } else {
            _alert(res, this.$t(res.data), false);
            this.loading = false;
          }
        });
      }
    },
  },
};
</script>
